import React from "react";
import { useTranslation } from "react-i18next";

interface MisconceptionSpecificFieldsProps {
  context: string;
  onChange: (context: string) => void;
  themeColor: string;
}

const MisconceptionSpecificFields: React.FC<
  MisconceptionSpecificFieldsProps
> = ({ context, onChange, themeColor }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <label
        className={`inline-block text-sm font-medium text-${themeColor}-700 dark:text-${themeColor}-300`}
      >
        {t("misconceptions.form.context")}
      </label>
      <textarea
        value={context}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full rounded-xl border-2 border-gray-200 dark:border-gray-700 p-4 text-base focus:ring-2 focus:ring-${themeColor}-500 focus:border-transparent dark:bg-gray-700/50 transition-all duration-200 min-h-[120px]`}
        placeholder={t("misconceptions.form.contextPlaceholder")}
      />
    </div>
  );
};

export default MisconceptionSpecificFields;
